module.exports = __webpack_public_path__ + "media/images/redesign-images/home/collegiate-logos/miami-university-3f53408400dd3cd7ecec214569869c68.svg";